module.exports = __webpack_public_path__ + "img/CSAT1.4a93f950.svg";